import { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";

function SortIcon(props: SvgIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="17"
            viewBox="0 0 15 17"
        >
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill="#21006E" fillRule="nonzero">
                    <path d="M6.30176482 3.7369526L10.2234503 -0.000432632685 14.0942036 3.63070797 13.2731964 4.50589203 10.23 1.65 7.12963518 4.6056474z"></path>
                    <path d="M10.8265 0.8522L10.8265 11.5922 9.6265 11.5922 9.6265 0.8522z"></path>
                    <path d="M0.827935179 12.9981526L3.927 15.952 6.97149639 13.097908 7.79250361 13.973092 3.92175028 17.6042326 0.0000648208238 13.8668474z"></path>
                    <path d="M4.5247 6.0116L4.5247 16.7516 3.3247 16.7516 3.3247 6.0116z"></path>
                </g>
            </g>
        </svg>
    );
}

export default SortIcon;
